import React from 'react';
import { Card, CardContent } from './ui/card';
import { Wrench, Zap, Flame, Settings, Shield, ThermometerSun } from 'lucide-react';

const Services = () => {
  const services = [
    {
      icon: Flame,
      title: 'Instalasi / Pemasangan',
      description: 'Pasang unit baru atau penggantian water heater lama.'
    },
    {
      icon: Zap,
      title: 'Penggantian Spare Part',
      description: 'Ganti elemen pemanas, thermostat, anode, valve, dan komponen rusak'
    },
    {
      icon: ThermometerSun,
      title: 'Pengecekan Sistem Listrik / Gas',
      description: 'Pastikan instalasi aman dan sesuai standar.'
    },
    {
      icon: Settings,
      title: 'Perbaikan (Repair)',
      description: 'Mengatasi masalah seperti air tidak panas, mati total, bocor, atau error'
    },
    {
      icon: Wrench,
      title: 'Maintenance Rutin',
      description: 'Pembersihan unit & pengecekan rutin agar awet dan hemat listrik/gas'
    },
    {
      icon: Shield,
      title: 'Garansi Service',
      description: 'Jaminan service dengan garansi spare part dan workmanship'
    }
  ];

  return (
    <section id="layanan" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-16">
          <div className="inline-block bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-semibold mb-4">
            Layanan Kami
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Solusi Lengkap untuk
            <span className="text-blue-600"> Water Heater </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Kami menangani berbagai jenis kerusakan dan perawatan water heater Anda dengan profesional
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <Card
                key={index}
                className="group border-2 border-gray-200 hover:border-blue-500 hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
              >
                <CardContent className="p-6">
                  <div className="bg-blue-100 w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:bg-blue-600 transition-colors duration-300">
                    <Icon className="w-7 h-7 text-blue-600 group-hover:text-white transition-colors duration-300" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{service.title}</h3>
                  <p className="text-gray-600 leading-relaxed">{service.description}</p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Feature Banner */}
        <div className="mt-16 bg-gradient-to-r from-blue-600 to-blue-700 rounded-3xl p-8 md:p-12 text-white">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
            <div>
              <div className="text-4xl font-bold mb-2">10+</div>
              <div className="text-blue-100">Tahun Pengalaman</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">5000+</div>
              <div className="text-blue-100">Water Heater Diperbaiki</div>
            </div>
            <div>
              <div className="text-4xl font-bold mb-2">99%</div>
              <div className="text-blue-100">Kepuasan Pelanggan</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;